import { useMutation, useQueryClient } from "@tanstack/react-query";
import { axiosCompanyInstance } from "src/config/axios";
import { CustomerUpsertRequest } from "./useCreateMutation";
import { AxiosError } from "axios";
import { ErrorResponse } from "src/utils/response";
import { useSnackbar } from "notistack";
import { FormErrorObject } from "src/utils/types";
import { useTranslation } from "react-i18next";
import { RQ_CUSTOMER_GROUP_LIST_KEY } from "src/modules/group/hooks/useGroupList";

interface OwnProps {
    onSuccess?: () => void;
    onError?: (errors: FormErrorObject) => void;
}

export const useCustomerUpdateMutation = ({ onSuccess, onError }: OwnProps) => {
    const { enqueueSnackbar } = useSnackbar();
    const { t } = useTranslation();
    const queryClient = useQueryClient();
    return useMutation(
        async (values: CustomerUpsertRequest) => {
            const res = await axiosCompanyInstance.put(`customer/${values.id}`, values);

            return res?.data || null;
        },
        {
            onSuccess: () => {
                queryClient.invalidateQueries([RQ_CUSTOMER_GROUP_LIST_KEY]);
                if (onSuccess) {
                    onSuccess();
                }
            },
            onError: (err: AxiosError<ErrorResponse>) => {
                if (err.response?.data.errors) {
                    enqueueSnackbar(t("shared.validation.api." + err.response?.data.error), {
                        variant: "error",
                    });
                }
                if (err.response?.data.errors && onError) {
                    onError({
                        tokens: err.response?.data.errors.customerTokens
                            ? err.response?.data.errors.customerTokens
                            : "",
                        ...err.response?.data.errors,
                    });
                }
            },
        }
    );
};
